// Fehlercodes der KI-Auftraege-Endpunkte (portal-api, TQ #726): fail-closed statt Fallback.
// Der Code steht im JSON-Body (`code`), der HTTP-Status dient nur zur Absicherung.
export const TQ_ERR_KENNUNG_MISSING = 'tenant_kennung_missing'
export const TQ_ERR_CANCEL_UNAVAILABLE = 'cancel_unavailable'

// Das Backend antwortet auf DELETE derzeit immer mit 501 cancel_unavailable: Button gar nicht erst zeigen.
// Der 501-Pfad in Tasks.tsx bleibt als Sicherung; Flag auf true, sobald Abbrechen backendseitig geht.
export const TQ_CANCEL_SUPPORTED = false

export const MSG_TQ_NOT_ENABLED = 'KI-Aufträge sind für Ihre Organisation noch nicht freigeschaltet.'
export const MSG_TQ_CANCEL_UNAVAILABLE = 'Abbrechen ist derzeit nicht verfügbar.'

function errorCode(err: unknown, status: number): string | null {
  const res = (err as { response?: { status?: number; data?: { code?: unknown } } } | null)?.response
  if (!res || res.status !== status) return null
  return typeof res.data?.code === 'string' ? res.data.code : null
}

export function isTqNotEnabled(err: unknown): boolean {
  return errorCode(err, 409) === TQ_ERR_KENNUNG_MISSING
}

export function isTqCancelUnavailable(err: unknown): boolean {
  return errorCode(err, 501) === TQ_ERR_CANCEL_UNAVAILABLE
}
